/**
 * @generated SignedSource<<21c93eec20156ceb6a5bf4a94b13996c>>
 * @relayHash 2a5f4905dcbc76da595fe8890b24298f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7f3c621bc35f3ba6d02a3b87249fc43d5791f8786491fb9e379a75bf485380ea

import type { ConcreteRequest, Query } from 'relay-runtime';
export type preloadContentSmartLinksForDraftQuery$variables = {
  contentId: string;
};
export type preloadContentSmartLinksForDraftQuery$data = {
  readonly confluence_contentSmartLinksForDraft: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: string;
      readonly url: string;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type preloadContentSmartLinksForDraftQuery = {
  response: preloadContentSmartLinksForDraftQuery$data;
  variables: preloadContentSmartLinksForDraftQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "PaginatedSmartLinkList",
    "kind": "LinkedField",
    "name": "confluence_contentSmartLinksForDraft",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "ScalarField",
            "name": "url"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "preloadContentSmartLinksForDraftQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "preloadContentSmartLinksForDraftQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2a5f4905dcbc76da595fe8890b24298f",
    "id": "7f3c621bc35f3ba6d02a3b87249fc43d5791f8786491fb9e379a75bf485380ea",
    "metadata": {},
    "name": "preloadContentSmartLinksForDraftQuery",
    "operationKind": "query",
    "text": "query preloadContentSmartLinksForDraftQuery($contentId:ID!){confluence_contentSmartLinksForDraft(id:$contentId){nodes{__typename,url}}}"
  }
};
})();

(node as any).hash = "c2988d2bbcf31a9c9c8985520d25900f";

export default node;
